<div class="row">
    <div class="col-12 col-md-5 mx-auto p-5">
        <div class="card m-md-4">
            <div class="card-body">
                <ng-container *ngIf="isSuccess">
                    <div class="text-center">
                        <h2 class="fw-bold pt-3 d-flex align-items-center text-center justify-content-center">
                            <i class="material-icons text-primary fs-3">check_circle</i>&nbsp; Link Sent
                        </h2>
                        <div class="text-muted mt-3">
                           The Link to reset your password has been sent<br>to your email.
                        </div>
                        <div class="mt-4">
                            <a [class.disabled]="loading.status" class="btn-link fw-bold text-nowrap" routerLink="/login">
                                Back to login
                            </a>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!isSuccess">
                    <div class="d-flex">
                        <div>
                            <div class="p-3">
                                <img [src]="'/assets/logo.png'">
                            </div>
                        </div>
                        <div>
                            <h2 class="fw-bold pt-3">Forgot Password</h2>
                            <p class="text-muted">
                                Type your email, we'll send you a link<br>to reset your password.
                            </p>
                        </div>
                    </div>
                    <form class="p-3 col-12" [formGroup]="theForm" #thisForm="ngForm" (ngSubmit)="submitForm(theForm)" novalidate>
                        <div class="form-floating mb-4">
                            <input type="email" formControlName="email" [class.is-invalid]="theForm.get('email')?.invalid && (thisForm.submitted || theForm.get('email')?.touched)" placeholder="name@example.com" class="form-control" required>
                            <label>Email</label>
                            <div class="text-danger position-absolute text-end w-100" *ngIf="theForm.get('email')?.invalid && (thisForm.submitted || theForm.get('email')?.touched)">
                                <small class="small" *ngIf="theForm.get('email')?.errors?.required">Type email</small>
                                <small *ngIf="theForm.get('email')?.errors?.pattern">Email isn't valid</small>
                                <small *ngIf="theForm.get('email')?.errors?.serverError">{{theForm.get('email')?.errors?.serverError}}</small>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <button type="submit" [attr.disabled]="loading.status?'disabled':null" class="btn btn-primary py-2 px-4 w-100">
                                    Send me a link
                                </button>
                            </div>
                            <div class="col-12 text-center mt-4">
                                <a [class.disabled]="loading.status" class="btn-link text-nowrap" routerLink="/login">
                                    Back to login
                                </a>
                            </div>
                        </div>
                    </form>
                </ng-container>
            </div>
        </div>
    </div>
</div>
